import React, { useState } from "react";
import "./datatable.scss";
import { Space, Input, Button, Image, message, Popover } from "antd";
import type { ColumnsType } from "antd/es/table";
import { EditOutlined, DeleteOutlined } from "@ant-design/icons";
import moment from "moment";
import { AppTable } from "../common";

interface Contentdata {
  key?: string;
  _id?: string;
  id?: string; // legacy field, keeping for backward compatibility
  title?: string;
  image?: string;
  content?: string;
  hash?: string;
  themeId?: string;
}

interface DataTableProps {
  setshowModel: (value: boolean) => void;
  setEditable: (value: boolean) => void;
  deleteArticle: (value: any) => void;
  editContent: (value: any) => void;
  isOpen: boolean;
  contentData: Contentdata[];
  action?: React.ReactNode;
}
function DataTableArticle({
  setshowModel,
  setEditable,
  isOpen,
  contentData,
  deleteArticle,
  editContent,
  action,
}: DataTableProps) {
  const [open, setOpen] = useState(false);

  const showModal = () => {
    setOpen(true);
  };

  const hideModal = () => {
    setOpen(false);
  };

  const [searchText, setSearchText] = useState("");

  const columns: ColumnsType<Contentdata> = [
    {
      title: "ID",
      dataIndex: "_id",
      key: "_id",
      filteredValue: [searchText],
      defaultSortOrder: "descend",
      sorter: (a: any, b: any) => (a._id || a.id || "").localeCompare(b._id || b.id || ""),
      onFilter: (value, record) => {
        return (
          String(record._id || record.id).toLowerCase().includes(value.toLocaleString()) ||
          String(record.title).toLowerCase().includes(value.toLocaleString()) ||
          String(record.hash).toLowerCase().includes(value.toLocaleString())
        );
      },
    },
    {
      title: "Title",
      dataIndex: "title",
      key: "title",
      render: (text) => (text.length > 15 ? `${text.slice(0, 100)}...` : text),
    },
    {
      title: "Image",
      dataIndex: "image",
      key: "image",
      render: (_, record) => (
        <Space size="middle">
          <Image src={record.image} width={60} height={60} alt={"image"} />
        </Space>
      ),
    },
    {
      title: "Content",
      dataIndex: "content",
      key: "content",
      render: (text) => (
        <>
          <p dangerouslySetInnerHTML={{ __html: text.slice(0, 100) }} />
        </>
      ),
    },
    {
      title: "Hash",
      dataIndex: "hash",
      key: "hash",
    },
    {
      title: "Theme ID",
      dataIndex: "themeId",
      key: "themeId",
    },
       {
      title: "Date",
      dataIndex: "createdAt",
      key: "createdAt",
      render: (text) => <div>{moment(text).format("DD-MM-YYYY hh:mm A")}</div>,
    },
    {
      title: "Action",
      key: "action",
      render: (_, record) => (
        <Space size="middle">
          <Button
            className="table_pill_btn table_pill_btn--view"
            icon={<EditOutlined />}
            onClick={() => {
              setshowModel(!isOpen);
              setEditable(true);
              editContent(record._id || record.id);
            }}
          >
            Edit
          </Button>
          <Popover
            content={
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  gap: "10px",
                }}
              >
                <Button
                  style={{ backgroundColor: "green", width: "100%", color: "#fff" }}
                  onDoubleClick={() => deleteArticle(record._id || record.id)}
                >
                  Yes
                </Button>
              </div>
            }
            title="Please Double click to delete."
          >
            <Button
              className="table_pill_btn table_pill_btn--danger"
              icon={<DeleteOutlined />}
            >
              Delete
            </Button>
          </Popover>
        </Space>
      ),
    },
  ];

  return (
    <div className="dataTable">
      <div className="filterMenu">
        {action}
        <Input.Search
          onSearch={(value) => {
            setSearchText(value);
          }}
          onChange={(e) => {
            setSearchText(e.target.value);
          }}
          className="searchField"
          placeholder="Search here..."
        />
      </div>
      <AppTable
        className="dataGrid"
        columns={columns}
        dataSource={contentData}
      />
    </div>
  );
}

export default DataTableArticle;
